var map = {
	"./banks-logos/ru-absolut.png": "7863",
	"./banks-logos/ru-akbars.png": "a34a",
	"./banks-logos/ru-alfa.png": "b179",
	"./banks-logos/ru-atb.png": "a48f",
	"./banks-logos/ru-avangard.png": "87c8",
	"./banks-logos/ru-binbank.png": "2915",
	"./banks-logos/ru-ceb.png": "8e87",
	"./banks-logos/ru-cetelem.png": "5987",
	"./banks-logos/ru-citi.png": "d12c",
	"./banks-logos/ru-globex.png": "aa07",
	"./banks-logos/ru-gpb.png": "77a3",
	"./banks-logos/ru-hcf.png": "f641",
	"./banks-logos/ru-jugra.png": "7f6a",
	"./banks-logos/ru-mib.png": "2854",
	"./banks-logos/ru-mkb.png": "3dba",
	"./banks-logos/ru-mob.png": "b548",
	"./banks-logos/ru-mts.png": "7ce8",
	"./banks-logos/ru-novikom.png": "691c",
	"./banks-logos/ru-open.png": "f2a5",
	"./banks-logos/ru-otp.png": "c0ad",
	"./banks-logos/ru-pochta.png": "7857",
	"./banks-logos/ru-psb.png": "2a8f",
	"./banks-logos/ru-raiffeisen.png": "059e",
	"./banks-logos/ru-reb.png": "09b1",
	"./banks-logos/ru-ren.png": "a1f7",
	"./banks-logos/ru-rgs.png": "6739",
	"./banks-logos/ru-rosbank.png": "8761",
	"./banks-logos/ru-roscap.png": "debc",
	"./banks-logos/ru-rossiya.png": "83b7",
	"./banks-logos/ru-rsb.png": "89aa",
	"./banks-logos/ru-rshb.png": "179b",
	"./banks-logos/ru-sberbank.png": "d619",
	"./banks-logos/ru-skb.png": "7541",
	"./banks-logos/ru-smp.png": "5dc0",
	"./banks-logos/ru-sovkom.png": "be54",
	"./banks-logos/ru-spb.png": "fb13",
	"./banks-logos/ru-sviaz.png": "8dfc",
	"./banks-logos/ru-tcb.png": "3449",
	"./banks-logos/ru-tinkoff.png": "5ec0",
	"./banks-logos/ru-trust.png": "ccd1",
	"./banks-logos/ru-ubrd.png": "22b1",
	"./banks-logos/ru-ucb.png": "b9b3",
	"./banks-logos/ru-uralsib.png": "9981",
	"./banks-logos/ru-vbrr.png": "748b",
	"./banks-logos/ru-veb.png": "d057",
	"./banks-logos/ru-vozrozhdenie.png": "2095",
	"./banks-logos/ru-vtb.png": "569d",
	"./banks-logos/ru-vtb24.png": "8d86",
	"./banks-logos/ru-zenit.png": "cdf8",
	"./brands-logos/american-express-black.png": "30aa",
	"./brands-logos/american-express-colored.png": "095c",
	"./brands-logos/american-express-white.png": "4b1a",
	"./brands-logos/diners-club-black.png": "b4c7",
	"./brands-logos/diners-club-colored.png": "90ab",
	"./brands-logos/diners-club-white.png": "9802",
	"./brands-logos/discover-black.png": "27be",
	"./brands-logos/discover-colored.png": "1e59",
	"./brands-logos/discover-white.png": "ea0e",
	"./brands-logos/jcb-black.png": "3a77",
	"./brands-logos/jcb-colored.png": "ecf4",
	"./brands-logos/jcb-white.png": "a0ce",
	"./brands-logos/maestro-black.png": "4779",
	"./brands-logos/maestro-colored.png": "4395",
	"./brands-logos/maestro-white.png": "7076",
	"./brands-logos/master-card-black.png": "4ffa",
	"./brands-logos/master-card-colored.png": "b9df",
	"./brands-logos/master-card-white.png": "30bb",
	"./brands-logos/mir-black.png": "9c89",
	"./brands-logos/mir-colored.png": "d68d",
	"./brands-logos/mir-white.png": "3d8c",
	"./brands-logos/unionpay-black.png": "8b31",
	"./brands-logos/unionpay-colored.png": "584d",
	"./brands-logos/unionpay-white.png": "6924",
	"./brands-logos/visa-black.png": "e644",
	"./brands-logos/visa-colored.png": "01dd",
	"./brands-logos/visa-white.png": "f065"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7236";